var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.106,
    height: 41.961,
    viewBox: "0 0 36.106 41.961",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 219"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 43",
    d: "M-12 0h27.036l2.592 27.84h-32.106z",
    transform: "translate(16.478 12.121)",
    style: {
      strokeLinejoin: "round",
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 44",
    d: "M4828.542-392.55v-9.457a5.909 5.909 0 0 1 6.12-4.918 5.737 5.737 0 0 1 6 4.918v9.457",
    transform: "translate(-4816.579 408.925)",
    style: {
      strokeLinejoin: "bevel",
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeWidth: 4
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.022997c7b800a09734e4981e06aa16b9.svg";
export { ForwardRef as ReactComponent };